import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { get_labor_data } from "../../../services/employeeApi";
import { formatDate } from "../../../utils/date_utils";
import { Button } from "react-bootstrap";
import SharedModal from "../../../components/UiComponent/SharedContentModal";
import AssignProjectForm from "../../Project/assignProject";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import BasicTable from "../../../components/UiComponent/customTable";
const LaborList = () => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [laborId, setLaborId] = useState();
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const handleButtonSubmit = () => {
    handleCloseModal();
  };
  const LaborListQuery = useQuery(["labor_list"], () => get_labor_data());
  const laborDatas = useMemo(() => {
    return LaborListQuery.data || [];
  }, [LaborListQuery.data]);
  if (LaborListQuery.isLoading) {
    return <div>Loading...</div>;
  }
  if (LaborListQuery.isError) {
    return <div>Error: {LaborListQuery.error.message}</div>;
  }
  const openAssignProjectModal = (event, id) => {
    event.preventDefault();
    handleShowModal();
    setLaborId(id);
  };

  const laborColumns = [
    {
      header: "full_name",
      accessor: "first_name",
      accessorFn: (row) => `${row.first_name} ${row.father_name} `,
    },
    {
      header: "phone",
      accessorKey: "phone",
    },
    {
      header: "sex",
      accessorKey: "sex",
    },
    {
      header: "project",
      accessorFn: (row) =>
        `${row.project_labor[0] === null ? 0 : row.project_labor.length}`,
    },
    {
      header: "registration_date",
      accessorFn: (row) => `${formatDate(row.createdAt)}`,
    },
    {
      header: "action",
      accessor: "id",
      cell: (row) => (
        <Button
          variant="btn btn-info btn-sm"
          onClick={(e) => openAssignProjectModal(e, row.row.original.id)}
        >
          {t("assign_project")}
        </Button>
      ),
    },
  ];
  return (
    <div>
      <BasicTable
        data={laborDatas}
        columns={laborColumns}
        title={`labor_list`}
        actionButton={
          <Link
            to="/labor-add"
            className="btn btn-sm btn-info position-relative d-flex align-items-center justify-content-between"
          >
            {t("add_labor")}
          </Link>
        }
      />

      <SharedModal
        show={showModal}
        title="select_project_and_assign"
        onHide={handleCloseModal}
        centered={true}
        backdrop="static"
        keyboard={false}
        content={
          <AssignProjectForm
            onSubmitButton={handleButtonSubmit}
            parentID={laborId}
          />
        }
      />
    </div>
  );
};
export default LaborList;
